import serverCall from "../../serverCall";

const getTextTranslations = () => {
  try {
    return serverCall.get(`/ai-conversation/my/text-translations`);
  } catch (error) {
    throw error;
  }
};

const getDocumentTranslations = () => {
  try {
    return serverCall.get(`/ai-conversation/my/document-translations`);
  } catch (error) {
    throw error;
  }
};

const getAudioTranslations = () => {
  try {
    return serverCall.get(`/ai-conversation/my/audio-translations`);
  } catch (error) {
    throw error;
  }
};

const getAIConversations = () => {
  try {
    return serverCall.get(`/ai-conversation/my/ai-conversations`);
  } catch (error) {
    throw error;
  }
};

const deleteAIConversations = () => {
  try {
    return serverCall.delete(`/users/deleteAidata/aiconversations`);
  } catch (error) {
    throw error;
  }
};

const deleteAudioTranslations = () => {
  try {
    return serverCall.delete(`/users/deleteAidata/audiotranslations`);
  } catch (error) {
    throw error;
  }
};

const deleteTranslations = () => {
  try {
    return serverCall.delete(`/users/deleteAidata/documenttranslations-texttranslations`);
  } catch (error) {
    throw error;
  }
};

const HistoryService = {
  getTextTranslations,
  getDocumentTranslations,
  getAudioTranslations,
  getAIConversations,
  deleteAIConversations,
  deleteAudioTranslations,
  deleteTranslations,
};

export default HistoryService;
